import ConfirmDialog from "../../components/customHelpers/ConfirmDialog";
import Controls from "../../components/controls/Controls";
import Norecords from "../../components/customHelpers/Norecords";
import Loading from "../../components/customHelpers/Loading";

import Layout from "../../components/layout/Layout";
import {
  TableBody,
  TableRow,
  TableCell,
  Typography,
  makeStyles,
} from "@material-ui/core";

import { Grid, Toolbar, InputAdornment } from "@material-ui/core";
import { useEffect, useRef, useState } from "react";

import { IoMdAdd } from "react-icons/io";
import { AiOutlineSearch } from "react-icons/ai";
import useTable from "../../components/customHelpers/useTable";
import Notify from "../../components/customHelpers/Notify";
import Notification from "../../components/customHelpers/Notification";
import { FiEdit, FiEye } from "react-icons/fi";

import Admin from "../../components/auth/Admin";
import Organization from "../../actions/organization";
import AddOrganization from "../../components/forms/addOrganization";
import Popup from "../../components/customHelpers/Popup";
import { AiFillCheckCircle } from "react-icons/ai";
import { AiFillCloseCircle } from "react-icons/ai";
import { Paper } from "@mui/material";
import { useHistory } from "react-router-dom";
import { Image_API } from "../../config";
const useStyles = makeStyles((theme) => ({
  activated: {
    color: theme.palette.success.main,
    fontWeight: "bold",
  },
  deactivated: {
    color: theme.palette.error.main,
    fontWeight: "bold",
  },
  image: {
    width: "50px",
    height: "50px",
    objectFit: "cover",
  },
}));
const headCells = [
  { id: "name", label: "Name" },
  { id: "email", label: "Email" },
  { id: "phoneNo", label: "Phone" },
  { id: "address", label: "Address" },
  { id: "status", label: "Status" },
  { id: "image", label: "Logo", disableSorting: true },
  { id: "actions", label: "Actions", disableSorting: true },
];
const OrganizationPage = () => {
  const classes = useStyles();
  const history = useHistory();

  const { NotifyMessage, notify, setNotify } = Notify();
  const { viewOrganizations, updateOrganization } = Organization();
  const [organization, setOrganization] = useState([]);
  const [recordForEdit, setRecordForEdit] = useState(null);
  const [openPopup, setOpenPopup] = useState(false);
  const [edite, setEdit] = useState(false);

  const [values, setValues] = useState({
    loading: false,
    reload: false,
  });
  const { loading, reload } = values;
  useEffect(() => {
    getAllOrganizations();
  }, [reload]);

  const [confirmDialog, setConfirmDialog] = useState({
    isOpen: false,
    title: "",
    subTitle: "",
  });
  const [filterFn, setFilterFn] = useState({
    fn: (items) => {
      return items;
    },
  });
  const getAllOrganizations = () => {
    setValues({ ...values, loading: true });
    viewOrganizations().then((data) => {
      if (data.err) {
        NotifyMessage({
          message: data.err,
          type: "error",
        });
        setValues({
          ...values,
          loading: false,
        });
      } else if (data.organizations) {
        setValues({
          ...values,
          loading: false,
        });
        setOrganization(data.organizations);
      }
    });
  };

  const { TblContainer, TblHead, TblPagination, recordsAfterPagingAndSorting } =
    useTable(organization, headCells, filterFn);

  const handleSearch = (e) => {
    e.target.value = e.target.value.trimLeft();
    let target = e.target;
    setFilterFn({
      fn: (items) => {
        const columns = ["organization_name", "email", "phoneNo", "address"];

        if (target.value == "") return items;
        else {
          return items.filter((x) => {
            return columns.some((column) => {
              return (
                x[column]
                  .toString()
                  .toLowerCase()
                  .indexOf(target.value.toLowerCase()) > -1
              );
            });
          });
        }
      },
    });
  };
  const updateOrganizationStatus = async (id, currentStatus) => {
    const newStatus = !currentStatus;
    updateOrganization({ inactive: newStatus }, id).then((data) => {
      if (data.err) {
        NotifyMessage({
          message: data.err,
          type: "error",
        });
      } else {
        setOrganization((prev) =>
          prev.map((org) =>
            org.id === id ? { ...org, inactive: newStatus } : org
          )
        );
        NotifyMessage({
          message: `Status updated successfully.`,
          type: "success",
        });
      }
    });
  };
  return (
    <Layout>
      <Admin>
        <div className="card">
          <Typography variant="h6" className="page-header">
            Organizations
          </Typography>
          <Toolbar>
            <Controls.Input
              label="Search organization"
              className="searchInput"
              fullWidth
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <AiOutlineSearch />
                  </InputAdornment>
                ),
              }}
              onChange={handleSearch}
            />

            <Controls.Button
              text="Add Organization"
              variant="outlined"
              startIcon={<IoMdAdd />}
              className="newButton"
              onClick={() => {
                setOpenPopup(true);
                setRecordForEdit(null);
                setEdit(false);
              }}
            />
          </Toolbar>

          <Grid container>
            <Grid item xs={12} className="card__body">
              {loading ? (
                <Loading />
              ) : (
                <Paper style={{ overflowX: "auto" }}>
                  <TblContainer>
                    <TblHead />
                    <TableBody>
                      {recordsAfterPagingAndSorting().length > 0 ? (
                        recordsAfterPagingAndSorting().map((item) => (
                          <TableRow key={item.id}>
                            <TableCell>{item.organization_name}</TableCell>
                            <TableCell>{item.email}</TableCell>
                            <TableCell>{item.phoneNo}</TableCell>
                            <TableCell>{item.address}</TableCell>
                            <TableCell
                              className={
                                item.inactive
                                  ? classes.deactivated
                                  : classes.activated
                              }
                            >
                              {item.inactive ? "Deactivated" : "Activated"}
                            </TableCell>{" "}
                            <TableCell>
                              <img
                                className={classes.image}
                                src={`${Image_API}/${item.profilePicture}`}
                                alt={item.organization_name} // Meaningful alt text
                              />
                            </TableCell>
                            <TableCell>
                              <Controls.ActionButton
                                color="primary"
                                title="Update"
                                onClick={() => {
                                  setOpenPopup(true);
                                  setRecordForEdit(item);
                                  setEdit(true);
                                }}
                              >
                                <FiEdit fontSize="medium" />
                              </Controls.ActionButton>
                              <Controls.ActionButton
                                color="secondary"
                                onClick={() =>
                                  updateOrganizationStatus(
                                    item.id,
                                    item.inactive
                                  )
                                }
                                title={item.inactive ? "Activat" : "Deactivat"}
                              >
                                {item.inactive ? (
                                  <AiFillCheckCircle fontSize="medium" />
                                ) : (
                                  <AiFillCloseCircle fontSize="medium" />
                                )}
                              </Controls.ActionButton>
                              <Controls.ActionButton
                                color="primary"
                                title="View Detail"
                                onClick={() => {
                                  history.push(
                                    `/admin/organization/${item.id}`
                                  );
                                }}
                              >
                                <FiEye fontSize="medium" />
                              </Controls.ActionButton>
                            </TableCell>
                          </TableRow>
                        ))
                      ) : (
                        <Norecords col={6} />
                      )}
                    </TableBody>
                  </TblContainer>
                  <TblPagination />
                </Paper>
              )}
            </Grid>
          </Grid>

          <ConfirmDialog
            confirmDialog={confirmDialog}
            setConfirmDialog={setConfirmDialog}
          />
          <Notification notify={notify} setNotify={setNotify} />
        </div>
        <Popup
          title="Organization Form"
          openPopup={openPopup}
          setOpenPopup={setOpenPopup}
        >
          <AddOrganization
            NotifyMessage={NotifyMessage}
            setOpenPopup={setOpenPopup}
            recordForEdit={recordForEdit}
            setOrganization={setOrganization}
            edite={edite}
          />
        </Popup>
      </Admin>
    </Layout>
  );
};

export default OrganizationPage;
